import { render, staticRenderFns } from "./PermissionPicker.vue?vue&type=template&id=28ef2ab4&scoped=true&"
import script from "./PermissionPicker.vue?vue&type=script&lang=js&"
export * from "./PermissionPicker.vue?vue&type=script&lang=js&"
import style0 from "./PermissionPicker.vue?vue&type=style&index=0&id=28ef2ab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ef2ab4",
  null
  
)

export default component.exports